module.exports = __webpack_public_path__ + "img/order_delivery.4de14c71.png";